import { logger } from '#utils/logging/logger';

export function getIsMediaOffline(meta: string | null | undefined) {
	let isMediaOffline = false;

	if (meta && typeof meta === 'string') {
		try {
			const parsedMetaInfo = JSON.parse(meta);

			if (parsedMetaInfo && parsedMetaInfo.offline) {
				isMediaOffline = true;
			}
		} catch (err: any) {
			logger.error(err, `Error while parsing meta data for audio/video module: %s`, meta);
		}
	}

	return isMediaOffline;
}
